import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /api/v1/payment/payout-accounts/default?provider_type=doctor
export const fetchDefaultPayoutAccountReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_default_payout_account,
  async ({ provider_type = "doctor" } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDefaultPayoutAccount}?provider_type=${provider_type}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      return rejectWithValue(getLocalizedErrorMessage({ response }, i18n));
    } catch (error) {
      // A missing default account is not a hard error - just return null.
      console.error("Error fetching default payout account:", error);
      return rejectWithValue(getLocalizedErrorMessage(error, i18n));
    }
  },
);
